import React from 'react';

// Import images
import userImg from '../assets/user.png';
import checkImg from '../assets/check.png';
import globeImg from '../assets/globe.png';
import fileImg from '../assets/file.png';
import heartImg from '../assets/heart.png';
import messageImg from '../assets/message.png';

const WhoAreWe = () => {
  const features = [
    {
      image: userImg,
      title: "Servizi Personalizzati",
      description: "Seguiamo personalmente pratiche CAF e Patronato con un approccio su misura. Ogni caso viene analizzato in modo concreto per trovare soluzioni rapide e adatte alla situazione reale."
    },
    {
      image: checkImg,
      title: "Assistenza Legislativa",
      description: "Lavoriamo costantemente aggiornati sulle normative fiscali, previdenziali e sull’immigrazione, offrendo supporto chiaro e operativo per affrontare cambiamenti e procedure amministrative."
    },
    {
      image: globeImg,
      title: "Supporto agli Stranieri",
      description: "Accompagniamo cittadini stranieri nella gestione delle pratiche e nella comprensione delle regole italiane, aiutandoli ad accedere ai servizi e ai diritti disponibili."
    },
    {
      image: fileImg,
      title: "Burocrazia Semplificata",
      description: "Rendiamo più semplici procedure spesso complesse, riducendo tempi, errori e passaggi inutili, con un supporto diretto dall’inizio alla conclusione della pratica."
    },
    {
      image: heartImg,
      title: "Guida Inclusiva",
      description: "Ascoltiamo ogni persona senza pregiudizi, spiegando in modo chiaro cosa fare e quali sono le possibilità reali, passo dopo passo."
    },
    {
      image: messageImg,
      title: "Coinvolgimento della Comunità",
      description: "Restiamo attivi sul territorio informando e supportando la comunità attraverso aggiornamenti, incontri e comunicazione online."
    }
  ];


  return (
    <section className="pb-10 md:py-8 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Title and Gradient Underline */}
        <h2 className="text-lg md:text-3xl font-bold text-start md:text-center text-slate-800 mb-1 md:mb-3">
          CHI SIAMO?
        </h2>
        <div className="w-28 md:w-40 h-1 mx-0 md:mx-auto mb-6 md:mb-6 rounded-full bg-gradient-to-r from-[#F2C231] to-[#C69A32]" />

        <p className="max-w-2xl mx-auto text-sm md:text-base text-slate-600 text-center mb-4 md:mb-6">
          Il centro nasce dal lavoro diretto del team, che ogni giorno seguono personalmente cittadini, famiglie e lavoratori nella gestione di pratiche fiscali, previdenziali e di immigrazione. L’approccio è pratico: ascolto della situazione reale, verifica dei documenti, spiegazioni chiare e accompagnamento fino alla conclusione della pratica. L’obiettivo è ridurre tempi e passaggi inutili, offrendo un unico punto di riferimento per chi deve risolvere problemi amministrativi concreti e avere risposte precise.
        </p>
        {/* Feature Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-16">
          {features.map((feature, index) => (
            <div key={index} className="text-left text-justify">
              <div className="flex justify-start mb-2 md:mb-4">
                <div className="w-10 h-10 md:w-16 md:h-16 bg-slate-700 rounded-md flex items-center justify-center">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-8 h-8 md:w-12 md:h-12 object-contain" // Increased from w-8 h-8
                  />
                </div>
              </div>
              <h3 className="text-base md:text-xl font-bold text-slate-800 mb-1 md:mb-3 text-left">{feature.title}</h3>
              <p className="text-gray-600 md:text-base text-xs leading-relaxed tracking-tight text-left">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoAreWe;
